import { AppBar, AppBarProps, styled, Theme, Toolbar } from '@mui/material';

export const AppBarStyled = styled(AppBar)((props: { theme: Theme } & AppBarProps) => ({
  zIndex: props.theme.zIndex.drawer + 101,
  opacity: props.hidden ? '0%' : '100%',
  pointerEvents: props.hidden ? 'none' : 'auto',
  transition: 'opacity 0.2s',
}));

export const ToolbarStyled = styled(Toolbar)({
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
});

export const AppbarHuan = styled(AppBar)(({ theme }) => ({
  background: `linear-gradient(to right, ${theme.palette.primary.main} 0%, #757373 60%) !important`,
}));
